<template>
	<div class="appUploadCsvOrAddStoreDetails">
		<el-row :gutter="20">
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="top-margin">
				<div class="text-center">
					<span
						>Create accounts for Head Office, Stores, Users, Kitchen and
						Suppliers via .csv</span
					>
				</div>
				<div>
					<el-row :gutter="20">
						<el-col
							:xs="24"
							:sm="12"
							:md="12"
							:lg="12"
							:xl="12"
							class="top-margin"
						>
							<a
								href="https://s3.ap-south-1.amazonaws.com/nymbleup-public/templates/Nymble_Login_Access+_+Account_Setup.csv"
								class=""
							>
								<BaseButton buttonclass="btn p-2 text-xs">
									Download Template
								</BaseButton>
							</a>
						</el-col>
						<el-col
							:xs="24"
							:sm="12"
							:md="12"
							:lg="12"
							:xl="12"
							class="top-margin"
						>
							<div class=" flex " style="height: 100%;">
								<label class="btn p-2 text-xs">
									Upload CSV
									<input
										id="setupUserAccounts"
										type="file"
										name="File Upload"
										accept=".csv"
										class="csv-file-style"
										@change="getCsvFile($event, 'setupUserAccounts')"
									/>
								</label>
							</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="top-margin">
				<div class="text-center">
					<span>Create Accounts Manually</span>
				</div>
				<div>
					<el-row :gutter="20">
						<el-col
							:xs="24"
							:sm="{ span: 12, offset: 6 }"
							:md="{ span: 12, offset: 6 }"
							:lg="{ span: 12, offset: 6 }"
							:xl="{ span: 12, offset: 6 }"
							class="top-margin"
						>
							<BaseButton buttonclass="btn p-2 text-xs" @click="goToAddStore">
								Create Account
							</BaseButton>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<!-- <el-dialog
      title="Errors in Csv File"
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :before-close="closeTableDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table :data="errorsInCsv">
        <el-table-column
          property="row"
          label="ROW"
          width="150"
        />
        <el-table-column
          property="column"
          label="COLUMN"
          width="200"
        />
        <el-table-column
          property="details"
          label="DETAILS"
        />
      </el-table>
    </el-dialog> -->
	</div>
</template>

<script>
import Papa from "papaparse";
import { serverAddr } from "../../../networkConfig.js";
import CsvService from "../../../services/csvService";
import { SetupUserAccounts } from "../../../../mixins/processCsvFunctions/setupUserAccounts.mixin";
import { EventBus } from "../../../eventBus";
export default {
	name: "AppUploadCsvOrAddStoreDetails",
	mixins: [SetupUserAccounts],
	props: [],
	data() {
		return {
			// dialogVisible: false,
			selectedFileType: "",
			errorsInCsv: []
		};
	},
	created() {
		// if (window.localStorage.getItem("errorsInCsv") !== null) {
		// 	this.errorsInCsv = JSON.parse(window.localStorage.getItem("errorsInCsv"));
		// 	this.dialogVisible = true;
		// }
	},
	mounted() {
		EventBus.$on("resetCsvVariablesEvent", () => {
			console.log(`inside ${this.$route.name}`);
			this.resetVariables();
		});
	},
	methods: {
		goToAddStore() {
			this.$emit("hide-popup");
			// this.$store.commit("uploadCSVDialog", false);
			this.$router.push("/account/add").catch(()=>{});
		},
		getCsvFile(event, fileId) {
			if (fileId == "setupUserAccounts") {
				this.selectedFileType = "accounts";
				if (event.target.files[0].size > 100000) {
					this.uploadCsv(event.target.files[0]);
					console.log("Nithin to validate on server");
					return;
				}
				this.getCities()
					.then(response => {
						response.forEach(element => {
							this.cities.push(element.name);
						});
					})
					.then(() => {
						this.handleFileSelect(event.target.files[0], fileId);
					})
					.catch(err => {
						console.log(err);
					});
			}

			var element = document.getElementById(fileId);
			element.onclick = event => {
				event.target.value = null;
				this.resetVariables();
			};
		},
		handleFileSelect(file, csvName) {
			// parse csv file data into json object and
			// send the data to validate to check if
			//there are any errors
			// Papa.LocalChunkSize = 2000000;
			Papa.parse(file, {
				header: true,
				dynamicTyping: true,
				skipEmptyLines: true,
				chunk: function(chunk, parser) {
					console.log("chunk", chunk);
					this.processSetupUserAccounts(chunk);
					return chunk;
				}.bind(this),
				complete: results => {
					if (this.errorsInCsv.length) {
						// console.log("route", this.$route.path);
						window.localStorage.setItem(
							"errorsInCsv",
							JSON.stringify(this.errorsInCsv)
						);

						window.open(this.$route.path, "_blank");
						// this.dialogVisible = true;
					} else {
						this.uploadCsv(file);
					}
					console.log("parse complete");
				}
			});
		},
		uploadCsv(file) {
			var formData = new FormData();
			formData.append("file", file);
			formData.append("type", this.selectedFileType);
			formData.append("outlets", "");
			formData.append("start_date", "");
			formData.append("end_date", "");
			CsvService.csvFileUpload(formData)
				.then(response => {
					if (response.status == 200) {
						// this.resetVariables();
						// this.dialogVisible = false;
						// this.$store.commit("uploadCSVDialog", false);
						this.$router.push("/app-store-details").catch(()=>{});
						this.$notify.success({
							title: "Success",
							message: "Success",
							type: "success"
						});
					} else {
						this.$notify.success({
							title: "Error",
							message: "unable to upload",
							type: "error"
						});
					}
				})
				.catch(error => {
					console.log(error);
				})
				.finally(() => {
					this.resetVariables();
				});
		},
		resetVariables() {
			this.selectedFileType = "";
			this.errorsInCsv = [];
			this.regionsMapping = {};
			// this.cities = [];
			window.localStorage.removeItem("errorsInCsv");
		},
		closeTableDialog() {
			// this.dialogVisible = false;
			// this.dialogVisible = false;
			// this.resetVariables();
		}
		// closeDialog() {
		// 	this.dialogVisible = false;
		// 	this.$store.commit("uploadCSVDialog", false);
		// },
		// processSetupUserAccounts(chunk) {

		// this.dataToShowInTable.data.headings = uploadLoginAccountSetUpData.data.filter(
		// 	(arr, i) => i === 0
		// ); // putting headings in dataToShowInTable
		// if (this.dataToShowInTable.data.headings[0].length === 27) {
		// 	const rowsArrInTable = this.dataToShowInTable.data.rows;
		// 	uploadLoginAccountSetUpData.data.map((arr, i) => {
		// 		// iterating over arrays in data field of json object returned from papa
		// 		rowsArrInTable.push([]); //creating empty array which will appear as rows in table.
		// 		if (i > 0 && arr.length === 27) {
		// 			// leaving the headings array
		// 			/*a*/
		// 			if (arr[0]) {
		// 				this.checkForString(arr[0])
		// 					? rowsArrInTable[i - 1].push({ value: arr[0], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[0], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*b*/
		// 			if (arr[1]) {
		// 				this.checkForString(arr[1])
		// 					? rowsArrInTable[i - 1].push({ value: arr[1], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[1], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*c*/
		// 			if (arr[2]) {
		// 				this.checkForAlphaNumeric(arr[2])
		// 					? rowsArrInTable[i - 1].push({ value: arr[2], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[2], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: false });
		// 			}
		// 			/*D*/
		// 			if (arr[3]) {
		// 				this.checkForAlphaNumeric(arr[3])
		// 					? rowsArrInTable[i - 1].push({ value: arr[3], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[3], isError: true });
		// 				this.find_duplicate_in_array(rowsArrInTable, "3");
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* E Account type */
		// 			if (arr[4]) {
		// 				this.checkForAlphaNumeric(arr[4])
		// 					? rowsArrInTable[i - 1].push({ value: arr[4], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[4], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* F Store type */
		// 			if (arr[5]) {
		// 				this.checkForAccountType(arr[5])
		// 					? rowsArrInTable[i - 1].push({ value: arr[5], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[5], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: "NA", isError: false });
		// 			}
		// 			/* G Name */
		// 			if (arr[6]) {
		// 				this.checkForString(arr[6])
		// 					? rowsArrInTable[i - 1].push({ value: arr[6], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[6], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: false });
		// 			}
		// 			/*H */
		// 			if (arr[7]) {
		// 				this.CheckForValidateEmail(arr[7])
		// 					? rowsArrInTable[i - 1].push({ value: arr[7], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[7], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: false });
		// 			}
		// 			/*I */
		// 			if (arr[8]) {
		// 				this.checkForString(arr[8])
		// 					? rowsArrInTable[i - 1].push({ value: arr[8], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[8], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* J*/
		// 			if (arr[9]) {
		// 				this.checkForString(arr[9])
		// 					? rowsArrInTable[i - 1].push({ value: arr[9], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[9], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*K*/
		// 			if (arr[10]) {
		// 				this.checkForString(arr[10])
		// 					? rowsArrInTable[i - 1].push({ value: arr[10], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[10], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*L*/
		// 			if (arr[11]) {
		// 				this.checkForString(arr[11])
		// 					? rowsArrInTable[i - 1].push({ value: arr[11], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[11], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*M*/
		// 			if (arr[12]) {
		// 				this.checkForString(arr[12])
		// 					? rowsArrInTable[i - 1].push({ value: arr[12], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[12], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*N */
		// 			if (arr[13]) {
		// 				this.checkForString(arr[13])
		// 					? rowsArrInTable[i - 1].push({ value: arr[13], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[13], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* o*/
		// 			if (arr[14]) {
		// 				this.checkForYes(arr[14])
		// 					? rowsArrInTable[i - 1].push({ value: arr[14], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[14], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*p*/
		// 			if (arr[15]) {
		// 				this.checkForYes(arr[15])
		// 					? rowsArrInTable[i - 1].push({ value: arr[15], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[15], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* Q*/
		// 			if (arr[16]) {
		// 				this.checkForYes(arr[16])
		// 					? rowsArrInTable[i - 1].push({ value: arr[16], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[16], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* R*/
		// 			if (arr[17]) {
		// 				this.checkForYes(arr[17])
		// 					? rowsArrInTable[i - 1].push({ value: arr[17], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[17], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*S */
		// 			if (arr[18]) {
		// 				this.checkForYes(arr[18])
		// 					? rowsArrInTable[i - 1].push({ value: arr[18], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[18], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*T*/
		// 			if (arr[19]) {
		// 				this.checkForYes(arr[19])
		// 					? rowsArrInTable[i - 1].push({ value: arr[19], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[19], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*U */
		// 			if (arr[20]) {
		// 				this.checkForYes(arr[20])
		// 					? rowsArrInTable[i - 1].push({ value: arr[20], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[20], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/* V */
		// 			if (arr[21]) {
		// 				this.checkForYes(arr[21])
		// 					? rowsArrInTable[i - 1].push({ value: arr[21], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[21], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*W */
		// 			if (arr[22]) {
		// 				this.checkForYes(arr[22])
		// 					? rowsArrInTable[i - 1].push({ value: arr[22], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[22], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*X*/
		// 			if (arr[23]) {
		// 				this.checkForYes(arr[23])
		// 					? rowsArrInTable[i - 1].push({ value: arr[23], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[23], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*y*/
		// 			if (arr[24]) {
		// 				this.checkForYes(arr[24])
		// 					? rowsArrInTable[i - 1].push({ value: arr[24], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[24], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 			/*Z*/
		// 			if (arr[25]) {
		// 				this.checkForYes(arr[25])
		// 					? rowsArrInTable[i - 1].push({ value: arr[25], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[25], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 				console.log("rowsArrInTable", rowsArrInTable);
		// 			}
		// 			/*Z*/
		// 			if (arr[26]) {
		// 				this.checkForYes(arr[26])
		// 					? rowsArrInTable[i - 1].push({ value: arr[26], isError: false })
		// 					: rowsArrInTable[i - 1].push({ value: arr[26], isError: true });
		// 			} else {
		// 				rowsArrInTable[i - 1].push({ value: null, isError: true });
		// 			}
		// 		}
		// 	});
		// 	console.log("dataToShowInTable", this.dataToShowInTable);
		// 	Papa.parse(store_csv, {
		// 		header: true,
		// 		dynamicTyping: true,
		// 		complete: results => {
		// 			console.log("results1", results);
		// 			this.openDialogforErrors(this.dataToShowInTable, csvName, results);
		// 		}
		// 	});
		// } else {
		// 	this.showCorrectFileSelectMessage();
		// }
		// },
	}
};
</script>

<style lang="scss" scoped>
@import "./appUploadCsvOrAddStoreDetails.scss";
</style>
<style>
/* close button css */
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close:hover {
	color: #3d3e3e;
}
</style>
